var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_evaluations_remoteEntry_mjs_ae5c9d28__;